import { ICertificateInputMap } from "~/interfaces/processFlowInterfaces"
import { RelationType } from '~/models/relationType'
import { IHasParent, ITrackedModel } from '~/interfaces/modelInterfaces'
import { IReferencePath } from '~/interfaces/referencePathInterfaces'
import { ObjectHelper } from '~/helpers/objectHelper'
import IRepo from '~/interfaces/repo'
import Repo from '~/state/modules/repo'
import { ProcessFlowMappedVariableType } from '../../../../formability/processFlowBuilder/enums/processFlowMappedVariableType'
import {GenerateDocumentStep} from "~/models/processFlows/steps/generateDocumentStep";
import {Logger} from "~/services/logger";
import ProcessFlowMappedVariableDefinition, {ProcessFlowMappedVariableClasses} from '~/models/processFlows/processFlowMappedVariableDefinition'
import ProcessFlowMappedVariable from '~/models/processFlows/steps/processFlowMappedVariable'

export class CertificateInputMap extends ProcessFlowMappedVariable implements ICertificateInputMap {
  parent: GenerateDocumentStep;
  certificate_input_id: string;
  list_input_alias: string;

  get formulaReferencePathsArray(): IReferencePath[] {
    return ObjectHelper.toArray(this.formula_reference_paths)
  }

  // UI Helper for dynamic fields tree
  _rootCertificateInputMap: CertificateInputMap;
  get rootCertificateInputMap(): CertificateInputMap {
    return this._rootCertificateInputMap;
  }
  set rootCertificateInputMap(inputMap: CertificateInputMap) {
    this._rootCertificateInputMap = inputMap;
  }

  constructor(parent: GenerateDocumentStep, json: Partial<ICertificateInputMap>, options?: {triggerChanges: boolean}) {
    super('certificate_input_maps', json);
    // needed so undo redo knows how to treat component (see TrackedModel reference: isCollectionRoot)
    this._isCollectionRoot = true;
    this.parent = parent;
    this._nameInParent = this.rootName
    this.defineProperty('certificate_input_id', json.certificate_input_id);
    this.defineProperty('list_input_alias', '');
  }

  // ******************** RELATIONS AND REPOS ******************** //
  static repo: IRepo<CertificateInputMap> = new Repo<CertificateInputMap>('certificateInputMaps', CertificateInputMap, {});
  repo: IRepo<this>;

  addToRepo(): void {
    CertificateInputMap.repo.add(this)
  }

  get className(): ProcessFlowMappedVariableClasses {
    return 'CertificateInputMap'
  }

  get EMBEDDED_MODELS(): { [key: string]: { type: any, relationType: RelationType } } {
    return ProcessFlowMappedVariableDefinition.embeddedModelDefinitionFactory('CertificateInputMap')
  }

  initializeEmbedded(parent: ICertificateInputMap & ITrackedModel, item: IReferencePath & IHasParent<ICertificateInputMap>, position: number = null, json: object = {}, selectItem: boolean = true) {
    const oldItem = this[item.rootName]
    item.triggerChanges = true
    item.parent = parent
    item.startTracking()
    this.placeChildrenInRelations(item, item.rootName, this)
    parent.trackCreationDeletion(item.client_id, oldItem?.asJson?.(), item.asJson(), item, true, oldItem)
    return item
  }

  get collectionKey() {
    return this._nameInParent
  }
  // ******************** RELATIONS AND REPOS END******************** //

}